// @flow
import * as React from 'react'
import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import Button from '../../components/BaseButton/BaseButton'
import styles from './buttonGroup-style.css'

type Props = {
  next?: {
    label: string,
    href: string,
  },
  back?: {
    label: string,
    href: string,
  },
  skip?: {
    label: string,
    href: string,
  },
  children?: React.Node,
  style?: {},
  alignRight?: boolean,
}

class ButtonGroup extends React.Component<Props> {
  static displayName = 'ButtonGroup'
  static propTypes = {
    next: PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
    }),
    back: PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
    }),
    skip: PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
    }),
    alignRight: PropTypes.bool,
    style: PropTypes.object,
  }

  render() {
    const { next, back, skip, style, children } = this.props

    if (children)
      return (
        <div className={styles.buttonGroup} style={style}>
          {children}
        </div>
      )

    if (!back && !next && !skip) return null

    if (!back && !skip)
      return (
        <div className={styles.buttonGroupSingle}>
          {next && <Button primary expands {...next} />}
        </div>
      )

    return (
      <div className={styles.buttonGroup}>
        {back && <Button small flat icon="back" {...back} />}
        {next && <Button primary expands {...next} />}
      </div>
    )
  }
}

export default ButtonGroup



// WEBPACK FOOTER //
// ./src/modules/ButtonGroup/ButtonGroup.js